import './types'

/*==================================
  共通処理
===================================*/
/*  ===== セグメント保持（初期データ） ===== */
let segmentInfoInitialData = {}

/**
 * 初期データをセット
 *
 * @param {SegmentFormData[]} segmentInitData - セグメント（初期データ）
 */
export function setSegmentInfoInitialData(segmentInitData) {
  segmentInfoInitialData = Object.fromEntries(segmentInitData.map((item) => [item.searchKey, item]))
}

/**
 * キーから初期データを取得
 *
 * @param {string} searchKey - セグメントの一意なキー
 * @returns {object | null} セグメントの初期データまたはnull
 */
export function getInitialDataBySegment(searchKey) {
  return segmentInfoInitialData[searchKey] || null
}
